export default class AcknowledgeAttachmentRequest {
    public attachmentId: string = "";
    public userId: string = "";
}